import { action, observable } from 'mobx';

import {
  getAssessmentInfo,
  // getActionRequired,
  // getActiveClaimTypeList,
  // getAllByStatus,
  // getAllWithoutNCI,
  // getAssessmentStatus,
  // getClinicInterpretationService,
  // getClinicList,
  // getCompanyList,
  // getConversationList,
  // getIMSApprovalCode,
  // getLanguageList,
  // getListInvoiceID,
  // getLookupConfigByTypes,
  // getPatientList,
  // getRooms,
  // getSpecificLookupConfigOrderNoByType,
  // getStaffGetAll,
  // getStaffList,
  // getTypists,
  // getWIROPrincipleLawyer,
} from './service';
import {
  UPLOAD_FILE_RULE,
  AssessmentReportType,
  ASSESSMENT_INFO,
} from './type';

class AddEditStore {
  @observable loading = true;
  @observable assessmentInfo = ASSESSMENT_INFO;
  //

  @observable uploadRule = UPLOAD_FILE_RULE;
  @observable steps = [
    { key: 0, step: 'claimDetails', active: false, title: 'Claim Details' },
    {
      key: 1,
      step: 'appointmentDetails',
      active: false,
      title: 'Appointment Details & Case Documents',
    },
    {
      key: 2,
      step: 'appointmentReminder',
      active: false,
      title: 'Appointment Reminder',
    },
    {
      key: 3,
      step: 'appointmentAttendance',
      active: false,
      title: 'Appointment Attendance & Case Cancellation',
    },
    {
      key: 4,
      step: 'dictations',
      active: false,
      title: 'Dictations & Report Information',
    },
    {
      key: 5,
      step: 'specialistPayment',
      active: false,
      title: 'Specialist Payment Information',
    },
    {
      key: 6,
      step: 'clientInvoice',
      active: false,
      title: 'Client Invoicing Information',
    },
    {
      key: 7,
      step: 'caseCorrespondence',
      active: false,
      title: 'Case Correspondence',
    },
    {
      key: 8,
      step: 'actionRequired',
      active: false,
      title: 'Action Required',
    },
  ];
  @observable upLoadType = [
    {
      key: 0,
      fileName: 'LOI',
      active: false,
      title: 'LETTER OF INSTRUCTION',
      belongToStep: 1,
      reportType: 1,
    },
    {
      key: 1,
      fileName: 'other documents',
      active: false,
      title: 'ADDITIONAL DOCUMENTS',
      belongToStep: 1,
      reportType: 9,
    },
    {
      key: 2,
      fileName: 'Equipment Checklist',
      active: false,
      title: "Claimant's Video Assessment Details",
      belongToStep: 1,
      reportType: 7,
    },
    {
      key: 3,
      fileName: 'Signed Consent',
      active: false,
      title: "Claimant's Video Assessment Details",
      belongToStep: 1,
      reportType: 6,
    },
    {
      key: 4,
      fileName: 'Equipment Checklist',
      active: false,
      title: 'Specialist Video Assessment Details',
      belongToStep: 1,
      reportType: 8,
    },
    {
      key: 5,
      fileName: 'Dictations',
      active: false,
      title: '',
      belongToStep: 4,
      reportType: 13,
    },
    {
      key: 6,
      fileName: 'Dictations Instruction',
      active: false,
      title: '',
      belongToStep: 4,
      reportType: 2,
    },
    {
      key: 7,
      fileName: 'Report Samples',
      active: false,
      title: '',
      belongToStep: 4,
      reportType: 14,
    },
    {
      key: 8,
      fileName: 'Report Templates',
      active: false,
      title: '',
      belongToStep: 4,
      reportType: 15,
    },
    {
      key: 9,
      fileName: 'Typed Report',
      active: false,
      title: '',
      belongToStep: 4,
      reportType: 19,
    },
    {
      key: 10,
      fileName: 'Report Draft',
      active: false,
      title: '',
      belongToStep: 4,
      reportType: 3,
    },
    {
      key: 11,
      fileName: 'Corrected Report',
      active: false,
      title: '',
      belongToStep: 4,
      reportType: 18,
    },
    {
      key: 12,
      fileName: 'Final Report',
      active: false,
      title: '',
      belongToStep: 4,
      reportType: 4,
    },
    {
      key: 13,
      fileName: 'Amended Report',
      active: false,
      title: '',
      belongToStep: 4,
      reportType: 5,
    },
    {
      key: 14,
      fileName: 'Doctor Invoice',
      active: false,
      title: '',
      belongToStep: 5,
      reportType: 11,
    },
    {
      key: 15,
      fileName: 'Payment Receipt',
      active: false,
      title: '',
      belongToStep: 5,
      reportType: 12,
    },
    {
      key: 16,
      fileName: 'Client Files',
      active: false,
      title: '',
      belongToStep: 6,
      reportType: 10,
    },
    {
      key: 17,
      fileName: 'Funding Approval',
      active: false,
      title: 'WiroFundingApproval',
      belongToStep: 0,
      reportType: 20,
    },
  ];

  @action fetchAssessmentInfo = (id = 0) => {
    Promise.all([getAssessmentInfo(id)]).then(
      action(([assessmentInfo]) => {
        this.assessmentInfo = assessmentInfo;
        this.loading = false;
      }),
    );
  };

  @action handleActiveUploadType = (stepKey, isActive = false) => {
    const uploadTypesActive = this.upLoadType.map(i => {
      if (i.belongToStep === stepKey) {
        return {
          ...i,
          active: isActive,
        };
      } else return { ...i, active: false };
    });
    this.upLoadType = uploadTypesActive;
    return AssessmentReportType;
  };
}

export default new AddEditStore();
